module.exports = __webpack_public_path__ + "377cab6384d0a5a6fc4c766eacb2a92e.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../images/speakers/small/michael-henretty.jpg
// module id = 672
// module chunks = 0